import { render, staticRenderFns } from "./courseRecord.vue?vue&type=template&id=73fb1f66&scoped=true&"
import script from "./courseRecord.vue?vue&type=script&lang=js&"
export * from "./courseRecord.vue?vue&type=script&lang=js&"
import style0 from "./courseRecord.vue?vue&type=style&index=0&id=73fb1f66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fb1f66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\胶己人\\jjr_store_reservation\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73fb1f66')) {
      api.createRecord('73fb1f66', component.options)
    } else {
      api.reload('73fb1f66', component.options)
    }
    module.hot.accept("./courseRecord.vue?vue&type=template&id=73fb1f66&scoped=true&", function () {
      api.rerender('73fb1f66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/courseRecord.vue"
export default component.exports